<template>
    <div class="vant-card">
        <div class="dataFrom">

            <van-cell-group>
                <van-field v-model="dataFrom.startIccid" label="号段充值" @change="selectDefault()"
                    placeholder="请输入开始iccid/虚拟号号段" />
            </van-cell-group>
            <van-cell-group>
                <van-field v-model="dataFrom.endIccd" label="号段充值" placeholder="请输入结束iccid/虚拟号号段" />
            </van-cell-group>
            <br />
            <p style="color:red">号段充值和批量充值二选一，都填则优先批量充值</p>
            <div class="line">
                <label>批量充值</label>
                <div class="">
                    <textarea v-model="dataFrom.batchIccid" rows="5" @change="selectDefault()"
                        placeholder="多个卡号请用空格或者换行分隔"></textarea>
                </div>
            </div>

            <van-cell-group>
                <van-field readonly clickable name="picker" :value="groupName" class="ksea" label="套餐系列"
                    placeholder="请选择充值的套餐系列" @click="showPicker1 = true" />
                <van-popup v-model="showPicker1" position="bottom">
                    <van-picker show-toolbar :columns="columns1" @confirm="onConfirm1" @cancel="onCancel1" />
                </van-popup>
            </van-cell-group>

            <van-cell-group>
                <van-field readonly clickable name="picker" :value="pkgName" class="ksea" label="选择套餐"
                    placeholder="请选择充值的具体套餐" @click="showPicker2 = true" />
                <van-popup v-model="showPicker2" position="bottom">
                    <van-picker show-toolbar :columns="columns2" @confirm="onConfirm2" @cancel="onCancel2" />
                </van-popup>
            </van-cell-group>

            <van-cell-group>
                <van-field readonly clickable name="picker" :value="nextName" class="ksea" label="生效时间"
                    placeholder="请选择套餐的充值时间" @click="showPicker3 = true" />
                <van-popup v-model="showPicker3" position="bottom">
                    <van-picker show-toolbar :columns="columns3" @confirm="onConfirm3" @cancel="onCancel3" />
                </van-popup>
            </van-cell-group>

        </div>



        <mt-button type="primary" size="large" @click="inventSim">卡板充值（可用预存{{agentBalance}}/元）</mt-button>
        <!-- <p style="color:red;text-align: center;">预存款剩余 {{ agentBalance }}/元可用</p> -->
        <!-- <mt-button type="primary" size="large" @click="distribution">充值账户余额 （剩余 {{agentBalance}}/元可用） </mt-button>  -->

        <van-dialog v-model="inventFlg" title="充值金额" show-cancel-button messageAlign="left" @confirm="sureInventPrice">
            <van-field v-model="inventRmb" label="" placeholder="请输入你要充值的金额（元）" label-width="0" type="number" />
        </van-dialog>

    </div>
</template>
<script>
import { Toast, Dialog } from 'vant';
import { wxRequest } from '@/api/agent.js'
export default {
    name: 'card',
    data() {
        return {
            inventRmb: '',//用户充值金额
            inventFlg: false,//充值状态
            groupName: '',
            showPicker1: false,
            columns1: [],
            text: '',
            pkgName: '',
            showPicker2: false,
            columns2: [],

            nextName: '',
            showPicker3: false,
            columns3: [
                {
                    id: '0',
                    text: '本月生效'
                },
                {
                    id: '1',
                    text: '次月生效'
                }
            ],

            agentBalance: '0', //代理商剩余预存/元
            dataFrom: {
                soldPackageId: '',// 要充值的套餐
                isNextMonth: '0',
                startIccid: '',
                endIccd: '',
                remark: '手机端充值',
                batchIccid: '', //批量充值

            },
            pageNo: 0,
            perPageNum: 10,
            allPage: 0,
            pickerName: '',
            dataList: [],
            columns: [],
            showPicker: false,
            loading: false,
            finished: false,

            allGroup: [],
        }
    },
    async created() {
        // var appid = process.env.VUE_APP_APPID;
        // //获取总部公众号appid
        // await wxRequest("/sim/sys/appId", {}, "post").then(res => {
        //     if (res.data.code == 200) {
        //         appid = res.data.data.collectAppid;
        //     }
        // });
        // var redirectUrl = window.location.href;
        // var index = redirectUrl.indexOf('code');
        // redirectUrl = encodeURIComponent(redirectUrl);
        // if (index < 0) {
        //     window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
        // } else {
        //     var search = window.location.search;
        //     var startIndex = search.indexOf('code');
        //     var endIndex = search.indexOf('&', startIndex);
        //     var str = search.slice(startIndex, endIndex);
        //     var code = str.slice(str.indexOf('=') + 1);
        //     await wxRequest("/sim/bind/agentWx", { wxCode: code }, "post").then(res => {
        //         if (res.data.code != 200) {
        //             this.$messagebox.alert(res.data.message)
        //         }
        //     });
        // }


        // 获取套餐数据
        await wxRequest('sim/search/allow/pkgGroup', {}, 'get').then(res => {
            if (res.data.code === '200') {
                if (Array.isArray(res.data.data) && res.data.data.length > 0) {
                    res.data.data.forEach(item => {
                        this.columns1.push({ id: item.id, text: item.name })
                    })
                }
            } else {
                this.$messagebox.alert(res.data.message)
            }
        });
        this.getAgentPrice();


    },
    methods: {

        selectDefault() {
            wxRequest('sim/select/group/iccid', this.dataFrom, 'post').then(res => {
                if (res.data.code === '200') {
                    this.groupName = res.data.data[0].name;
                    this.dataFrom.pkgGroupId = res.data.data[0].id;
                    wxRequest('sim/investPkg/allow/list', { groupId: res.data.data[0].id }, 'get').then(res => {
                        if (res.data.code === '200') {
                            if (Array.isArray(res.data.data) && res.data.data.length > 0) {
                                res.data.data.forEach(item => {
                                    this.columns2.push({ id: item.id, text: item.packageName })
                                })
                            }
                        } else {
                            this.$messagebox.alert(res.data.message)
                        }
                    });
                }
            });
        },

        getAgentPrice() {
            // 获取代理商预充值金额
            wxRequest("sim/select/agent/balance", {}, "post").then(res => {
                if (res.data.code == 200) {
                    this.agentBalance = res.data.data;
                } else {
                    this.$messagebox.alert(res.data.message)
                }
            })
        },
        // 充值金额弹窗
        distribution() {
            this.inventFlg = true;
        },
        //充值弹窗确认按钮
        sureInventPrice() {
            if (!this.inventRmb || this.inventRmb <= 0) {
                Toast('请输入要充值的金额！')
                return
            }
            wxRequest("bindPhone/buy/sim/price", {}, "post").then(res => {
                if (res.data.code == 200) {
                    let result = res.data.data;
                    let sale = (this.inventRmb * result.invent) / 100;
                    Dialog.confirm({
                        title: '手续费提示',
                        message: "本次充值手续费需要" + sale + "元，确定要充值吗？"
                    }).then(() => {


                        wxRequest("sim/investOrder/phone/add/wx", { priceRmb: this.inventRmb }, "post").then(res => {
                            if (res.data.code == 200) {
                                //微信第三方
                                var param = res.data.data;
                                if (typeof WeixinJSBridge == "undefined") {
                                    if (document.addEventListener) {
                                        document.addEventListener(
                                            "WeixinJSBridgeReady",
                                            this.onBridgeReady,
                                            false
                                        );
                                    } else if (document.attachEvent) {
                                        document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                                        document.attachEvent(
                                            "onWeixinJSBridgeReady",
                                            this.onBridgeReady
                                        );
                                    }
                                } else {
                                    this.onBridgeReady(param);
                                }


                            } else {
                                this.$messagebox.alert(res.data.message)
                            }
                        })



                    }).catch(() => {
                        // on cancel
                    });

                } else {
                    this.$messagebox.alert(res.data.message)
                }
            })




        },

        //充值时唤起微信支付
        onBridgeReady(param) {
            let _this = this;
            WeixinJSBridge.invoke("getBrandWCPayRequest", param, function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    _this.$router.push({
                        path: "/agent/home"
                    })
                        .catch(() => { });
                }
            });
        },










        onConfirm1(value) {
            this.groupName = value.text
            this.dataFrom.pkgGroupId = value.id;
            wxRequest('sim/investPkg/allow/list', { groupId: value.id }, 'get').then(res => {
                if (res.data.code === '200') {
                    if (Array.isArray(res.data.data) && res.data.data.length > 0) {
                        res.data.data.forEach(item => {
                            this.columns2.push({ id: item.id, text: item.packageName })
                        })
                    }
                } else {
                    this.$messagebox.alert(res.data.message)
                }
            });



            this.showPicker1 = false;
        },
        onConfirm2(value) {
            this.pkgName = value.text
            this.dataFrom.soldPackageId = value.id
            this.showPicker2 = false;
        },
        onConfirm3(value) {
            this.nextName = value.text
            this.dataFrom.isNextMonth = value.id
            this.showPicker3 = false;
        },

        onCancel1() {
            this.showPicker1 = false;
        },
        onCancel2() {
            this.showPicker2 = false;
        },
        onCancel3() {
            this.showPicker3 = false;
        },


        // 获取代理商数据
        inventSim() {
            if ((!this.dataFrom.startIccid || !this.dataFrom.endIccd) && !this.dataFrom.batchIccid) {
                Toast('请输入要充值的卡号！')
                return
            }
            if (!this.dataFrom.soldPackageId) {
                Toast('请输入要充值的套餐！')
                return
            }

            if (this.agentBalance <= 0) {
                Toast('账户余额不足！请充值余额后 重新进入此页面充值')
                return
            }

            Dialog.confirm({
                title: '充值警示！',
                message: '1：请合理选择套餐的生效时间！ 部分套餐不支持次月操作,充值后套餐会过期！<br/>' +
                    '2: 充值后会有一定延迟，请耐心等待。不要重复连续充值！否则将会导致重复扣费！<br/>'
            }).then(() => {
                wxRequest("sim/invest/agent/phone/iccids", this.dataFrom, "post").then(res => {
                    if (res.data.code == 200) {
                        this.getAgentPrice();
                        this.$messagebox.alert('操作成功！正在异步执行充值')
                    } else {
                        this.$messagebox.alert(res.data.message)
                    }
                })
            }).catch(() => {
                // on cancel
            });
        },
        // 初始化数据
        getSimDistributRecordHandler() {
            var data = {
                pageNo: this.pageNo,
                iccidStart: this.dataFrom.iccidStart,
                iccidEnd: this.dataFrom.iccidEnd,
                iccid: this.dataFrom.iccid,
                perPageNum: this.perPageNum
            }
            wxRequest("sim/agent/listPage", data, "post").then(res => {
                if (res.data.code == 200) {
                    if (res.data.data.totalNum === 0) {
                        this.finished = true;
                        return
                    }
                    this.allPage = Math.ceil(res.data.data.totalNum / this.perPageNum)
                    this.loading = false;
                    if (this.pageNo == this.allPage) {
                        this.finished = true;
                    }
                    this.dataList = this.dataList.concat(res.data.data.resultList)
                    // this.$nextTick(function(){
                    //     window.scroll(0,0);
                    // })                        
                }
            })
        },



        onConfirm(value) {
            this.pickerName = value.text
            this.dataFrom.agentId = value.id
            this.showPicker = false;
        },
        onCancel() {
            this.showPicker = false;
        },
    }
}
</script>
<style lang="less" scoped>
.van-cell:not(:last-child)::after {
    border: 0
}

.vant-card {
    min-height: 100%;
    background: #F5F5F5;
    padding-top: 10px;

    .dataFrom {
        margin: 0px 14px 16px 14px;
        padding: 8px;
        padding-left: 16px;
        padding-right: 16px;
        border-radius: 8px;
        background: #fff;

        [class*=van-hairline]::after {
            border: 0
        }

        .van-cell {
            border-bottom: 1px solid #F5F5F5;
            padding-bottom: 20px;
            padding-right: 0;
            padding-top: 16px;
        }

        .van-cell-group:last-child {
            .van-cell {
                border: 0
            }
        }

        .ksea {
            /deep/.van-cell__value {
                .van-field__control {
                    background: url(./../../assets/agent/icon5.png) no-repeat right center;
                    background-size: 13px 8px;
                }
            }
        }

        .van-cell-group {
            /deep/.van-cell__title {
                color: #000;
            }

            /deep/.van-cell__value {
                .van-field__control {
                    line-height: 24px;
                }
            }
        }
    }

    button {
        margin: 16px 14px 0 14px;
        width: calc(100% - 28px);
        font-size: 14px;
        background: #1677FE;
        border-radius: 8px;
        height: 48px;
    }

    .content {
        margin-top: 32px;
        margin-left: 14px;
        margin-right: 14px;
        background: #fff;
        padding: 16px;
        border-radius: 8px;

        .vant-v {
            border-bottom: 1px solid #F5F5F5;
            margin-bottom: 16px;

            .van-row {
                padding-bottom: 8px;

                .van-col--2 {
                    img {
                        width: 15px;
                        height: 16px;
                    }
                }

                .van-col--18 {
                    color: #000;
                    font-size: 14px;
                }

                .van-col--4 {
                    color: #1677FE;
                    font-size: 14px;
                    text-align: right;
                }

                .van-col--17 {
                    color: #999;
                    padding-bottom: 8px;
                    font-size: 12px;
                }

                .van-col--5 {
                    color: #1677FE;
                    font-size: 14px;
                    text-align: right;
                }
            }
        }
    }
}

::v-deep .van-cell__value {
    border: 1px solid #cdcdcd;
    border-radius: 8px;
    height: 32px;
    line-height: 30px;

    .van-field__control {
        height: 32px;
        line-height: 30px;
        padding-left: 10px;
    }
}
</style>